import React, { useState } from "react";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { ReferalCard } from "@/components/ReferalCard/ReferalCard";
import { SortingBlock } from "@/components/SortingBlock/SortingBlock";
import { Pagination } from "@/ui/Pagination/Pagination";
import { NoReferalsIcon } from "@/assets/icons";
import { useReferalsDataContext } from "@/store/ReferalsProvider";
import { SORT_TYPE_PARAMS, useSortTypeStore } from "@/store/sortTypeStore";
import ContainerLoader from "@/ui/ContainerLoader/ContainerLoader";
import cls from "./styles.module.scss";

export const ActiveReferals = () => {
  const { activeReferals, loadActiveReferals } = useReferalsDataContext();
  const sortType = useSortTypeStore((s) => s.sortType);
  const activeReferalsList = activeReferals.results;
  const referalsPerPage = activeReferals.limit;

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const changePage = async (newPage: number) => {
    setIsLoading(true);

    setCurrentPage(newPage);
    const offset = (newPage - 1) * referalsPerPage;
    await loadActiveReferals(offset, SORT_TYPE_PARAMS[sortType]);

    setIsLoading(false);
  };

  const sortReferals = async (sortType: string) => {
    setIsLoading(true);

    const offset = (currentPage - 1) * referalsPerPage;
    await loadActiveReferals(offset, sortType);

    setIsLoading(false);
  };

  return (
    <>
      <FlexColumn gap={12}>
        <FlexRow justifyContent="space-between">
          <Typography className={cls.title}>Активные рефералы</Typography>

          <div className={cls.refCount}>{activeReferals.count} чел.</div>
        </FlexRow>

        <SortingBlock sortReferals={sortReferals} />

        {isLoading ? (
          <ContainerLoader />
        ) : (
          <>
            {!activeReferalsList || activeReferalsList.length === 0 ? (
              <FlexColumn
                gap={12}
                alignItems="center"
                className={cls.noActiveReferals}
              >
                <div className={cls.noReferalsIcon}>
                  <NoReferalsIcon />
                </div>
                <Typography className={cls.noReferalsTitle}>
                  Пока нет рефералов
                </Typography>
                <Typography className={cls.noReferalsDesc}>
                  Поделись ссылкой с другом — и он
                  <br />
                  появится здесь после регистрации
                </Typography>
              </FlexColumn>
            ) : (
              <FlexColumn gap={14}>
                {activeReferalsList.map((elem) => (
                  <ReferalCard
                    key={elem.telegram_user?.telegram_id}
                    referal={elem}
                  />
                ))}
              </FlexColumn>
            )}
          </>
        )}
      </FlexColumn>

      <Pagination
        currentPage={currentPage}
        onPageChange={changePage}
        list={activeReferals}
      />
    </>
  );
};
